// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import CaseCloserPaymentPlans from './data'

export default function CaseCloserPaymentPlansFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/CaseCloserPaymentPlans">
      <CaseCloserPaymentPlans {...props}>
        {children}
      </CaseCloserPaymentPlans>
    </Flow>
  )
}
